import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ConfigurationFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetConfiguration(confId: number): Observable<any> {
      return this._httpClient.get<any>(this._urlBase + 'api/Configuration?confId=' + confId);
  }
}
